var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 45,
    viewBox: "0 0 49 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1458 44.6489L20.6809 41.4947C8.37458 30.3353 0.25 22.9515 0.25 13.9428C0.25 6.55894 6.03279 0.800049 13.3927 0.800049C17.5506 0.800049 21.5412 2.73561 24.1458 5.77038C26.7505 2.73561 30.7411 0.800049 34.899 0.800049C42.2589 0.800049 48.0417 6.55894 48.0417 13.9428C48.0417 22.9515 39.9171 30.3353 27.6107 41.4947L24.1458 44.6489Z",
    fill: "#7CEB87"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrue);
export default __webpack_public_path__ + "static/media/True.a90d00ccec6061c6f4e3cc090f700d3c.svg";
export { ForwardRef as ReactComponent };